import React from 'react';

import { Box, useTheme } from '@mui/material';

import { Typography } from '../typography/typography';

export type BoardItem = {
  name: string;
  value: string;
};

interface BoardProps {
  items: BoardItem[];
  horizontal?: boolean;
}

export const Board: React.FC<BoardProps> = ({ items, horizontal = false }) => {
  const theme = useTheme();

  if (!items) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(3),
      }}
    >
      {items.map((item, index) => {
        const noHours = item.value.toLowerCase().includes('no hours');
        return (
          <Box
            key={index}
            sx={{
              display: 'flex',
              width: 'fit-content',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
              gap: '5px',
              overflow: 'hidden',
              padding: '6px 8px',
              borderRadius: '10px',
              border: noHours
                ? `1px solid ${theme.background.lightGrey3}`
                : `1px solid ${theme.colors.primary.main}`,
              backgroundColor: noHours
                ? theme.background.lightGrey2
                : theme.colors.primary.light,
            }}
          >
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: 13,
                color: noHours
                  ? theme.background.darkGrey
                  : theme.colors.primary.main,
              }}
            >
              {item.name}:
            </Typography>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: 15,
                color: noHours
                  ? theme.background.darkGrey2
                  : theme.colors.primary.main,
              }}
            >
              {item.value}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
